
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pickup",
      function () {
        return require("private-next-pages/pickup/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pickup"])
      });
    }
  